<template>
  <section
    class="flex flex-col justify-between p-4 border rounded-lg lg:flex-row"
  >
    <div class="flex flex-col items-center lg:flex-row gap-y-2 gap-x-6">
      <img
        @click="$router.go(-1)"
        class="inline pt-1 pb-2 mr-1 cursor-pointer"
        aria-hidden="true"
        title="go back"
        src="@/assets/svg/Caretleft.svg"
      />
      <div>
        <img
          :src="
            details.imageUrl ? details.imageUrl : '@/assets/svg/avatar2.svg'
          "
          class="rounded-full w-28 h-28"
        />
      </div>
      <div>
        <div class="flex flex-col text-center gap-x-2 lg:text-left lg:flex-row">
          <h1 class="text-[var(--grey900)] lg:text-2xl text-lg font-semibold">
            {{ details.name }} <small>({{ details.depotGroupName }})</small>
          </h1>

          <StatusTag :type="details.status" />
        </div>

        <div
          class="text-[var(--grey500)] text-sm flex lg:flex-row flex-col items-center gap-y-2 gap-x-4 my-3"
        >
          <div>
            <p>
              {{ details.houseNo }}, {{ details.street }}, {{ details.state }}
            </p>
          </div>
          <div class="flex gap-x-2">
            <img src="@/assets/svg/telephone.svg" alt="Phone number" />
            <p>{{ details.phone }}</p>
          </div>

          <router-link
            v-if="isTankManager"
            :to="{
              name: 'Live Tanks',
              query: { id: details.id },
            }"
          >
            <div class="flex font-semibold text-green-500 underline gap-x-2">
              <!-- <img src="@/assets/svg/telephone.svg" alt="Phone number" /> -->
              <p>View tanks</p>
            </div>
          </router-link>
        </div>
      </div>
    </div>

    <div class="flex items-center my-4 text-sm lg:my-0 gap-x-2">
      <button
        @click="handleOpenDrawers('price')"
        class="ml-2 px-3 py-1 rounded-md border border-[var(--grey900)] text-[var(--grey900)]"
      >
        Change Price
      </button>

      <button
        @click="handleOpenDrawers('inventory')"
        class="ml-2 px-3 py-1 rounded-md border border-[var(--grey900)] text-[var(--grey900)]"
      >
        Update Inventory
      </button>

      <a-dropdown>
        <button>
          <img src="@/assets/svg/moreOption.svg" class="h-7" />
        </button>

        <template #overlay>
          <a-menu class="">
            <a-menu-item
              v-for="(option, index) in options"
              :key="index"
              @click="option.func"
              class=""
            >
              <p
                :class="
                  option.name.toLowerCase() === 'suspend'
                    ? 'text-yellow-600 '
                    : option.name.toLowerCase() === 'activate'
                    ? 'text-green-600'
                    : option.name.toLowerCase() == 'delete'
                    ? 'text-red-600'
                    : 'black'
                "
              >
                {{ option.name }}
              </p>
            </a-menu-item>
          </a-menu>
        </template>
      </a-dropdown>

      <!-- <MoreOption
        :editHandler="editDrawerHandler"
        :options="options"
        :suspendLoader="suspendLoader"
        :deleteLoader="deleteLoader"
      /> -->
    </div>
  </section>

  <SuspendDepotModal
    :close="closeDepotStatusModal"
    :isOpen="isDepotStatusModalOpen"
    :status="depotStatus"
    :depotId="depotId"
    :getDepotDetails="getDepotDetails"
  />

  <DeleteDepotModal
    :close="closeDeleteModal"
    :isOpen="isDeleteModalOpen"
    :depotId="depotId"
  />
</template>

<script>
//services
import depotService from "@/services/depot-service";

import { lowerCase } from "@/utils/formatter";
import { useToast } from "vue-toastification";
import ClipLoader from "vue-spinner/src/ClipLoader.vue";

//components
import ProductTags from "@/components/UI/ProductTypes";
import StatusTag from "@/components/UI/Tags/StatusTag.vue";
import MoreOption from "@/components/UI/Buttons/MoreOption.vue";
import DeleteDepotModal from "@/components/pages/Depot/Modal/DeleteDepotModal.vue";
import SuspendDepotModal from "@/components/pages/Depot/Modal/SuspendDepotModal.vue";
export default {
  props: [
    "showDrawer",
    "details",
    "loader",
    "products",
    "getDepotDetails",
    "handleOpenDrawers",
    "handleCloseDrawers",
    "editDrawerHandler",
    "mapProductHandler",
  ],
  components: {
    ClipLoader,
    ProductTags,
    MoreOption,
    StatusTag,
    DeleteDepotModal,
    SuspendDepotModal,
  },
  created() {},
  data() {
    return {
      toast: useToast(),
      suspendLoader: false,
      deleteLoader: false,
      depotId: this.$route.query.id,
      options: [
        {
          name: "Edit",
          func: () => this.editDrawerHandler("open"),
        },
        {
          name: "Delete",
          func: this.openDeleteModal,
        },
        {
          name:
            lowerCase(this.details.status) == "active" ? "Suspend" : "Activate",
          func: this.openDepotStatusModal,
        },

        {
          name: "Map Product",
          func: () => this.mapProductHandler("open"),
        },
      ],

      isDepotStatusModalOpen: false,
      isDeleteModalOpen: false,
    };
  },
  computed: {
    depotStatus() {
      if (this.details) {
        return lowerCase(this.details.status);
      }
    },

    isTankManager() {
      const roles = localStorage.getItem("modules")
        ? JSON.parse(localStorage.getItem("modules"))
        : [];

      return roles?.some((role) => role?.toLowerCase() === "tank manager");
    },
  },

  mounted() {},
  methods: {
    //modals
    openDepotStatusModal() {
      this.isDepotStatusModalOpen = true;
    },
    closeDepotStatusModal() {
      this.isDepotStatusModalOpen = false;
    },

    openDeleteModal() {
      this.isDeleteModalOpen = true;
    },
    closeDeleteModal() {
      this.isDeleteModalOpen = false;
    },
  },
};
</script>

<style></style>
